import type { ComponentType } from '@grafikr/components';
import Splide from '@splidejs/splide';

const Component: ComponentType = (node) => {
  new Splide(node, {
    autoWidth: true,
    arrows: node.dataset.arrows !== 'false',
    pagination: false,
    omitEnd: true,
    focus: 0,
    flickPower: 200,
  }).mount();
};

export default Component;
